var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12M6 1.95a.3.3 0 0 1 .3.3v4.125a.3.3 0 1 1-.6 0V2.25a.3.3 0 0 1 .3-.3m0 6.375a.3.3 0 0 1 .3.3v.5a.3.3 0 1 1-.6 0v-.5a.3.3 0 0 1 .3-.3",
    clipRule: "evenodd"
  })));
});
const SvgAlertCircleFilledsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertCircleFilledsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDEyQzkuMzEzNzEgMTIgMTIgOS4zMTM3MSAxMiA2QzEyIDIuNjg2MjkgOS4zMTM3MSAwIDYgMEMyLjY4NjI5IDAgMCAyLjY4NjI5IDAgNkMwIDkuMzEzNzEgMi42ODYyOSAxMiA2IDEyWk01Ljk5OTk1IDEuOTQ5OTVDNi4xNjU2NCAxLjk0OTk1IDYuMjk5OTUgMi4wODQyNyA2LjI5OTk1IDIuMjQ5OTVWNi4zNzQ5NUM2LjI5OTk1IDYuNTQwNjQgNi4xNjU2NCA2LjY3NDk1IDUuOTk5OTUgNi42NzQ5NUM1LjgzNDI3IDYuNjc0OTUgNS42OTk5NSA2LjU0MDY0IDUuNjk5OTUgNi4zNzQ5NVYyLjI0OTk1QzUuNjk5OTUgMi4wODQyNyA1LjgzNDI3IDEuOTQ5OTUgNS45OTk5NSAxLjk0OTk1Wk01Ljk5OTk1IDguMzI0OTVDNi4xNjU2NCA4LjMyNDk1IDYuMjk5OTUgOC40NTkyNyA2LjI5OTk1IDguNjI0OTVWOS4xMjQ5NUM2LjI5OTk1IDkuMjkwNjQgNi4xNjU2NCA5LjQyNDk1IDUuOTk5OTUgOS40MjQ5NUM1LjgzNDI3IDkuNDI0OTUgNS42OTk5NSA5LjI5MDY0IDUuNjk5OTUgOS4xMjQ5NVY4LjYyNDk1QzUuNjk5OTUgOC40NTkyNyA1LjgzNDI3IDguMzI0OTUgNS45OTk5NSA4LjMyNDk1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";